import React, { FunctionComponent, ReactNode, useCallback } from 'react';
import Router from 'next/router';

export interface LinkRendererProps {
  href?: string,
  children: ReactNode,
}

/**
regex matches anything that starts with http and https (not a relative path) and isn't:
  ...//dove.it
  ...//www.dove.it
*/
const NOFOLLOW_HREF_REGEX = /^(https?:)?\/\/(?!(www\.)?dove\.it)/;
const RELATIVE_HREF_REGEX = /^(?!(https?:)?\/\/)/;

const LinkRenderer: FunctionComponent<LinkRendererProps> = ({
  href,
  children,
}) => {
  const noFollow = NOFOLLOW_HREF_REGEX.test(href);

  const onClick = useCallback((e) => {
    // override anchor behaviour if href looks relative or starts with our origin
    if (RELATIVE_HREF_REGEX.test(href) || href.indexOf(window.location.origin) === 0) {
      e.preventDefault();
      // try to route locally with path and, if fails, perform a full redirect
      const path = href.replace(window.location.origin, '');
      Router.push(path).catch(() => {
        window.location.href = href;
      });
    }
  }, [href]);

  return (
    // eslint-disable-next-line react/jsx-no-target-blank
    <a
      href={href}
      onClick={onClick}
      rel={noFollow ? 'nofollow noreferrer noopener' : ''}
      target={noFollow ? '_blank' : ''}
    >
      {children}
    </a>
  );
};

export default LinkRenderer;
